import React from 'react';
import { Zap, Brain, Target } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 px-4 bg-slate-950 relative overflow-hidden" data-id="element-133">
      {/* Decorative Grid */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20" data-id="element-134"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <span className="text-teal-500 font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-137">
            La Solución Técnica
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-138">
            PRESENTAMOS:{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-teal-200" data-id="element-139">
              EL RESET DE LOS 30+
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-140">
            Este no es un libro más. Es un protocolo de{' '}
            <span className="text-white font-bold" data-id="element-141">Ingeniería Mental</span> para
            latinos que ya no tienen tiempo que perder.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-142">
          {/* Card 1 */}
          <div className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-teal-500/50 transition-colors group" data-id="element-143">
            <div className="bg-teal-500/10 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-144">
              <Brain className="w-8 h-8 text-teal-400" data-id="element-145" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-146">
              Lealtades de Escasez
            </h3>
            <p className="text-slate-400" data-id="element-147">
              Identifica y elimina el código oculto que te hace sentir culpa por
              cobrar lo que realmente vales.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-yellow-500/50 transition-colors group" data-id="element-148">
            <div className="bg-yellow-500/10 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-149">
              <Target className="w-8 h-8 text-yellow-400" data-id="element-150" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-151">
              Extracción de Frenos
            </h3>
            <p className="text-slate-400" data-id="element-152">
              Corta quirúrgicamente con los parásitos emocionales y sociales que
              te roban la energía vital.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-900/50 border border-slate-800 p-8 rounded-2xl hover:border-red-500/50 transition-colors group" data-id="element-153">
            <div className="bg-red-500/10 w-14 h-14 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-154">
              <Zap className="w-8 h-8 text-red-400" data-id="element-155" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-156">
              Switch del Dueño
            </h3>
            <p className="text-slate-400" data-id="element-157">
              Deja de "buscar trabajo" y empieza a "crear activos" de alto
              valor. Cambia tu rol en el juego.
            </p>
          </div>
        </div>
      </div>
    </section>;
}